'use client';

import PropTypes from 'prop-types';

/**
 * GlobalError — root-level error boundary rendered by Next.js when the root layout crashes.
 * Must include its own <html> and <body> because it replaces the root layout entirely.
 * Intentionally uses no MUI or other context-dependent components so it prerenders cleanly.
 */
export default function GlobalError({ reset }) {
	return (
		<html lang="en">
			<body style={{ margin: 0, padding: 0 }}>
				<div
					style={{
						backgroundColor: '#F4F2F0',
						minHeight: '100vh',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						fontFamily: 'sans-serif',
						textAlign: 'center',
						padding: '16px'
					}}>
					<div>
						<h1 style={{ fontSize: '24px', marginBottom: '16px', color: '#2f3640' }}>Something went wrong</h1>
						<p style={{ color: '#666', maxWidth: '500px', margin: '0 auto 24px' }}>
							An unexpected error occurred. You can try again.
						</p>
						<button
							type="button"
							onClick={() => reset()}
							style={{
								backgroundColor: '#01584F',
								color: '#fff',
								border: 'none',
								padding: '12px 24px',
								borderRadius: '4px',
								cursor: 'pointer',
								fontSize: '16px',
								fontWeight: 600
							}}>
							Try again
						</button>
					</div>
				</div>
			</body>
		</html>
	);
}

GlobalError.propTypes = {
	reset: PropTypes.func.isRequired
};
